import {MultimediaVideoLazy} from 'app/components/multimedia/video/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineMultimediaVideo(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-multimedia-video')) {
        return;
    }

    customElements.define(
        'gem-multimedia-video',
        class extends WebComponentLoader {
            reactLazyComponent = MultimediaVideoLazy;
        },
    );
}
